import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, MenuItem, Tab, TextField, ThemeProvider } from "@mui/material";
import React from "react";

const DeliveryTab = ({
  theme,
  deliveryTabValue,
  handleChange,
  invoiceData,
  setInvoiceData,
  accountData,
  areaCodes,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <TabContext
        value={deliveryTabValue}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <TabList onChange={handleChange} aria-label="">
            <Tab label="Address" value="1" />
            <Tab label="Delivery Info" value="2" />
            <Tab label="Extras" value="3" />
          </TabList>
        </Box>
        {/* Address Tab */}
        <TabPanel value="1" sx={{ p: 0, paddingY: 1 }}>
          <div className=" flex flex-col">
            <div className=" mb-3 flex items-center gap-6">
              <TextField
                label="Address"
                name="notes"
                value={
                  accountData?.address1 ||
                  accountData?.address2 ||
                  accountData?.address3 ||
                  accountData?.address4
                }
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    notes: e.target.value,
                  })
                }
                placeholder="Address goes here ..."
                fullWidth
                variant="standard"
                multiline
                rows={1}
                size="small"
              />
              <TextField
                label="DO Nos"
                name="doNos"
                value={invoiceData.do_no}
                onChange={(e) =>
                  setInvoiceData({ ...invoiceData, do_no: e.target.value })
                }
                placeholder="DO Nos"
                fullWidth
                variant="standard"
                autoComplete="off"
                size="small"
              />
            </div>
            <div className=" flex items-center gap-6 mb-3">
              <TextField
                label="Contact number"
                name="contactNumber"
                value={accountData?.phone}
                onChange={(value) =>
                  setInvoiceData({
                    ...invoiceData,
                    contactNo: value,
                  })
                }
                placeholder="Contact number"
                fullWidth
                variant="standard"
                id="standard"
                autoComplete="off"
                size="small"
              />
              <TextField
                label="Fax number"
                name="faxNumber"
                // required
                value={accountData?.fax}
                placeholder="Fax number"
                fullWidth
                variant="standard"
                id="standard"
                autoComplete="off"
                size="small"
              />
            </div>

            <div className=" grid grid-cols-2 items-center gap-6">
              <TextField
                select
                fullWidth
                label="Area Code"
                variant="standard"
                value={accountData?.areacode}
                onChange={(e) =>
                  setInvoiceData({ ...invoiceData, areacode: e.target.value })
                }
              >
                {areaCodes.map((area) => (
                  <MenuItem key={area.ACODE_KEY} value={area.ACODE_KEY}>
                    {area.acode_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                variant="standard"
                value={accountData?.email}
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    portLoading: e.target.value,
                  })
                }
                placeholder="Email"
                sx={{ marginTop: 2 }}
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel value="2" sx={{ p: 0 }}>
          <div className="flex flex-col gap-4">
            <table className="w-full  text-sm">
              <tbody>
                <tr className="">
                  <td className="w-1/3 p-2 font-medium text-gray-700">
                    Delivery Status
                  </td>
                  <td className="p-2">
                    <TextField
                      select
                      fullWidth
                      variant="standard"
                      value={invoiceData?.status}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          status: e.target.value,
                        })
                      }
                    >
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Confirmed">Confirmed</MenuItem>
                      <MenuItem value="Shipped">Shipped</MenuItem>
                    </TextField>
                  </td>
                </tr>
                <tr className="b">
                  <td className="p-2 font-medium text-gray-700">
                    Mode of Transport
                  </td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.transportMode}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          transportMode: e.target.value,
                        })
                      }
                      placeholder="Mode of Transport"
                    />
                  </td>
                </tr>
                <tr className="">
                  <td className="p-2 font-medium text-gray-700">
                    Port of Loading
                  </td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.portLoading}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          portLoading: e.target.value,
                        })
                      }
                      placeholder="Port of Loading"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="p-2 font-medium text-gray-700">
                    Port of Discharge
                  </td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.portDischarge}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          portDischarge: e.target.value,
                        })
                      }
                      placeholder="Port of Discharge"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </TabPanel>
        <TabPanel value="3" sx={{ p: 0 }}>
          <div className="flex flex-col gap-4">
            <table className="w-full  text-sm">
              <tbody>
                <tr className="b">
                  <td className="p-2 font-medium text-gray-700">HS CODE </td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.hsCode}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          transportMode: e.target.value,
                        })
                      }
                      placeholder="HS CODE"
                    />
                  </td>
                </tr>
                <tr className="">
                  <td className="p-2 font-medium text-gray-700">
                    Total Weight{" "}
                  </td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.totalWeight}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          portLoading: e.target.value,
                        })
                      }
                      placeholder="Total Weight"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="p-2 font-medium text-gray-700">Bank Code</td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.bankCode}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          portDischarge: e.target.value,
                        })
                      }
                      placeholder="Bank Code"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="p-2 font-medium text-gray-700">Remarks</td>
                  <td className="p-2">
                    <TextField
                      fullWidth
                      variant="standard"
                      value={invoiceData.remarks}
                      onChange={(e) =>
                        setInvoiceData({
                          ...invoiceData,
                          remarks: e.target.value,
                        })
                      }
                      placeholder="Remarks"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </TabPanel>
      </TabContext>
    </ThemeProvider>
  );
};

export default DeliveryTab;
